import React from 'react';

import {ContainerSummary, StorableSummaryExtras} from 'constants/SampleConstants';
import {Measurement} from 'samples/transfers/Measurements';

interface Props {
  container: ContainerSummary;
  storableSummaryExtras?: StorableSummaryExtras | null;
  containerContentContainableId: string;
}

export default function ContainerContentConcentration(props: Props): JSX.Element | null {
  if (
    !(
      props.container &&
      props.storableSummaryExtras &&
      props.storableSummaryExtras.containableConcentrationsByContainerId
    )
  ) {
    return null;
  }
  const concentrationsByContainableId =
    props.storableSummaryExtras.containableConcentrationsByContainerId[props.container.id];

  if (!concentrationsByContainableId || Object.keys(concentrationsByContainableId).length === 0) {
    return null;
  }
  return <Measurement measurement={concentrationsByContainableId[props.containerContentContainableId]} />;
}
